module.exports = __webpack_public_path__ + "static/img/xzggr.00f43c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xzggr.png
// module id = FfSs
// module chunks = 0